import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full" data-id="element-329">
    <div className="flex items-center mb-4" data-id="element-330">
      <div className="w-12 h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-gold font-serif font-bold text-xl border border-brand-gold/30 mr-4 shrink-0" data-id="element-331">
        {initials}
      </div>
      <div data-id="element-332">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-333">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-334" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-335">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-336">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text italic flex-grow text-[13px]" data-id="element-337">"{text}"</p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    text: 'La primera noche dormí de corrido por primera vez en meses. Solo con el protocolo del Tomo I.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    text: 'El Test de Sal me mostró exactamente el rincón que yo evitaba. En 3 días el ambiente cambió.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    text: 'Vivía con personas escépticas. El Modo Discreto me permitió hacer el trabajo sin que nadie lo notara.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-338">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-339">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-340" />)}
      </div>
    </Section>;
};
export const ExtendedTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Córdoba',
    product: 'Colección Maestra',
    text: 'La primera noche dormí de corrido por primera vez en meses. Tenía insomnio desde que nos mudamos. El protocolo nocturno del Tomo I fue un antes y después.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    product: 'Colección Completa',
    text: 'El Test de Sal me mostró exactamente el rincón que yo evitaba. En 3 días el ambiente cambió. Mi marido, que no cree en nada de esto, me dijo que la casa se sentía distinta.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    product: 'Colección Maestra',
    text: 'Vivía con personas escépticas. El Modo Discreto me permitió hacer el trabajo sin que nadie lo notara. Los cambios los sintieron todos.'
  }, {
    initials: 'RM',
    name: 'Romina M.',
    location: 'Buenos Aires',
    product: 'Colección Completa',
    text: 'Corrí la cama 40 cm después del diagnóstico geopático. En una semana dormía bien por primera vez en dos años.'
  }];
  return <Section className="bg-brand-surface/50 rounded-3xl my-16" data-id="element-341">
      <div className="text-center mb-12" data-id="element-342">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-343">
          ❤️ MÁS PERSONAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-344">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-345" />)}
      </div>
    </Section>;
};